// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#legalInfo[data-v-44f57686]{color:#999;font-size:12px}#legalInfo .agb-lock-icon[data-v-44f57686]{color:#000;height:20px;width:20px}#legalInfo p[data-v-44f57686]{margin-bottom:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
